exports.f = Object.getOwnPropertySymbols;



// WEBPACK FOOTER //
// ./techpad-upgrade/~/core-js/modules/_object-gops.js